import React, { useEffect } from 'react';
import { Container, Grid } from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';
import { useBuild } from '../contexts/BuildContext';
import HydrationQueryColumn from '../feed_builder/hydration/HydrationQueryColumn';
import EnrichedResultsColumn from '../components/EnrichedResultsColumn';
import HydrationInfoColumn from '../feed_builder/hydration/HydrationInfoColumn';

const HydrationService = () => {
  const { setCurrentContext } = useGlobal();
  const { hits } = useBuild();

  useEffect(() => {
    setCurrentContext({
      product: 'build',
      page: 'hydration',
      ...(hits?.length && { numCandidates: hits.length }),
    });
    return () => setCurrentContext(null);
  }, [hits?.length, setCurrentContext]);

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Grid container spacing={2} sx={{ height: 'calc(100vh - 120px)' }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <HydrationQueryColumn />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <EnrichedResultsColumn />
        </Grid>
        <Grid size={{ xs: 12, md: 2 }}>
          <HydrationInfoColumn />
        </Grid>
      </Grid>
    </Container>
  );
};

export default HydrationService;
